import { SettingTheme } from "features/Setting"

export const SettingThemePages = () => {
    return (
        <SettingTheme />
    )
}